import gql from 'graphql-tag';

export const bulkAssignMemberMutation = gql`
  mutation bulkAssignMember(
    $serviceRequestIds: [String!]!
    $assignee: String!
  ) {
    bulkAssignMember(
      serviceRequestIds: $serviceRequestIds
      assignee: $assignee
    ) {
      successCount
      failureCount
      failures {
        serviceRequestId
        reason
      }
    }
  }
`;

